import { z } from 'zod';
import {
  type FeatureFlagInput,
  type FeatureFlagOutput,
  type FeatureFlagDefinition,
} from '@hungryroot/feature-flag-lib';

const booleanSchema = z
  .union([z.literal('0'), z.literal('1')])
  .transform((value) => {
    return value === '1';
  });

export const flagDefinitions = {
  'web.feature-flag.client-side-experiment-enrollment.enabled': {
    name: 'web.feature-flag.client-side-experiment-enrollment.enabled',
    schema: booleanSchema,
  },
  'web.feature-flag.salad-shooter.enabled': {
    name: 'web.feature-flag.salad-shooter.enabled',
    schema: booleanSchema,
  },
  'web.feature-flag.delivery-rating-module.enabled': {
    name: 'web.feature-flag.delivery-rating-module.enabled',
    schema: booleanSchema,
  },
  'web.feature-flag.perceived_value_questions.enabled': {
    name: 'web.feature-flag.perceived_value_questions.enabled',
    schema: booleanSchema,
  },

  'web.feature-flag.amount-of-food-module.enabled': {
    name: 'web.feature-flag.amount-of-food-module.enabled',
    schema: booleanSchema,
  },
  'web.feature-flag.checkout_v2.enabled': {
    name: 'web.feature-flag.checkout_v2.enabled',
    schema: booleanSchema,
  },

  // feature flags shared between BE and FE
  // uses BE naming convention
  'web.login_challenge': {
    name: 'web.login_challenge',
    schema: z.enum(['recaptcha']),
  },
  'web.signup_challenge': {
    name: 'web.signup_challenge',
    schema: z.enum(['recaptcha']),
  },
} as const satisfies Record<string, FeatureFlagDefinition>;

export type FeatureFlagsSchema = typeof flagDefinitions;
export type FeatureFlagDef<T extends FeatureFlags> = FeatureFlagsSchema[T];
export type FeatureFlags = keyof typeof flagDefinitions;
export type FeatureFlagInputType<T extends FeatureFlags> = FeatureFlagInput<
  FeatureFlagDef<T>['schema']
>;
export type FeatureFlagValueType<T extends FeatureFlags> = FeatureFlagOutput<
  FeatureFlagDef<T>['schema']
>;
export const featureFlagNames = Object.keys(flagDefinitions) as FeatureFlags[];
